import { render, staticRenderFns } from "./CoResourceBlock.vue?vue&type=template&id=1f85c8a8&"
import script from "./CoResourceBlock.vue?vue&type=script&lang=ts&"
export * from "./CoResourceBlock.vue?vue&type=script&lang=ts&"
import style0 from "./CoResourceBlock.vue?vue&type=style&index=0&id=1f85c8a8&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports